// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AndroidFilledSvg from "@ant-design/icons-svg/es/asn/AndroidFilled";
import AntdIcon from '../components/AntdIcon';

var AndroidFilled = function AndroidFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AndroidFilledSvg
  }));
};

AndroidFilled.displayName = 'AndroidFilled';
export default React.forwardRef(AndroidFilled);